import { DashboardNavigationListItem } from '@modules/dashboard/components/DashboardNavigationListItem';
import { List, ListItem, ListItemButton } from '@mui/material';
import { DashboardListItem } from 'generated/graphql';

interface DashboardListProps {
  dashboards: DashboardListItem[];
  hasMore?: boolean;
  onClose: () => void;
  onSeeAllClick?: () => void;
  testID: string;
}

export const DashboardList = ({
  dashboards,
  hasMore = false,
  onClose,
  onSeeAllClick,
  testID,
}: DashboardListProps) => {
  return (
    <List data-testid={testID}>
      {dashboards.map((dashboard) => (
        <DashboardNavigationListItem
          dashboard={dashboard}
          key={dashboard.id}
          onClose={onClose}
        />
      ))}
      {hasMore && (
        <ListItem disablePadding>
          <ListItemButton
            onClick={onSeeAllClick}
            sx={{
              width: '100%',
              color: 'primary.main',
            }}
          >
            SEE ALL
          </ListItemButton>
        </ListItem>
      )}
    </List>
  );
};
